export const gridColumnClasses = {
    '1': 'grid-cols-1',
    '2': 'grid-cols-2',
    '3': 'grid-cols-3',
    '4': 'grid-cols-4',
    '5': 'grid-cols-5',
    '6': 'grid-cols-6',
    '7': 'grid-cols-7',
    '8': 'grid-cols-8',
    '9': 'grid-cols-9',
    '10': 'grid-cols-10',
    '11': 'grid-cols-11',
    '12': 'grid-cols-12',
    'md:1': 'md:grid-cols-1',
    'md:2': 'md:grid-cols-2',
    'md:3': 'md:grid-cols-3',
    'md:4': 'md:grid-cols-4',
    'md:5': 'md:grid-cols-5',
    'md:6': 'md:grid-cols-6',
    'md:7': 'md:grid-cols-7',
    'md:8': 'md:grid-cols-8',
    'md:9': 'md:grid-cols-9',
    'md:10': 'md:grid-cols-10',
    'md:11': 'md:grid-cols-11',
    'md:12': 'md:grid-cols-12',
    'lg:1': 'lg:grid-cols-1',
    'lg:2': 'lg:grid-cols-2',
    'lg:3': 'lg:grid-cols-3',
    'lg:4': 'lg:grid-cols-4',
    'lg:5': 'lg:grid-cols-5',
    'lg:6': 'lg:grid-cols-6',
    'lg:7': 'lg:grid-cols-7',
    'lg:8': 'lg:grid-cols-8',
    'lg:9': 'lg:grid-cols-9',
    'lg:10': 'lg:grid-cols-10',
    'lg:11': 'lg:grid-cols-11',
    'lg:12': 'lg:grid-cols-12',
}

export const getGridColumnClass = (key, screenSize = null) => {
    return gridColumnClasses[screenSize ? (screenSize + ':' + key) : key];
}

export const gridColumnSpanClass = {
    full: '',
}
